module.exports = __webpack_public_path__ + "img/3.177b9a0f.png";